export function jobs(){



    $(document).ready(function () {
        $('#choose-file').change(function () {
            var i = $(this).parent().children('label').clone();
            var file = $('#choose-file')[0].files[0].name;
            $(this).parent().children('label').children('.filename').text(file);
        }); 


            if($( "[name='city']" ).length > 0){
            var url = '/wp-admin/admin-ajax.php';


            $.ajax({
                url: url,
                type: 'POST',
                data:{
                    action:'frenchCities',
                },
                
                success: function (res) {
                    res=JSON.parse(res);
                $( "[name='city']" ).autocomplete({
                    source: res.results.map(a => a.name)
                });
                
                }
            });  
        }
     });



}